module.exports = __webpack_public_path__ + "static/media/new-york-40.6230a793.jpg";